import React from 'react';
import styles from '.././styles.module.scss';
import {AnnouncementItems} from '../consts/types';
import {sendAnalyticsMonitor} from '../../../utils/monitoring';
import {Dialog, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../data/texts';
import {DialogContent} from './DialogContent';
import {Footer} from './Footer';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';
import {isRTL} from '../../../Localization';
import {getAnnouncementsShowMoreLink} from './utils';

interface AnnouncementWelcomDialogPrpos {
    welcomeAnnouncement: AnnouncementItems;
    onClose: () => void;
    onForward: () => void;
    showMoreLinkHandler: (linkUrl: string) => void;
}
export const AnnouncementWelcomeDialog = (props: AnnouncementWelcomDialogPrpos) => {
    const {welcomeAnnouncement, onClose, onForward} = props;
    const {content, title, additionalContent, monitoring, lottieContent, linkText} =
        welcomeAnnouncement;
    const forwardBtnText = texts.nextBtn;
    const backwardsBtnText = texts.cancelBtn;

    const isRtl = isRTL();
    const linkUrl = getAnnouncementsShowMoreLink(isRtl);

    const handleConfirmBtn = () => {
        if (monitoring?.forwardBtn) {
            sendAnalyticsMonitor(monitoring.forwardBtn);
        }
        onForward();
    };

    const handleBackBtn = () => {
        if (monitoring?.backwardBtn) {
            sendAnalyticsMonitor(monitoring.backwardBtn);
        }
        onClose();
    };

    const handleClose = () => {
        if (monitoring?.closeBtn) {
            sendAnalyticsMonitor(monitoring.closeBtn);
        }
        onClose();
    };

    return (
        <Dialog
            size="small"
            width={640}
            isOpen={true}
            closeIcon={
                <ModernTooltip position="top" tooltip={texts.closeTooltip}>
                    <Icon icon={PriorityIcon.closeSmall} />
                </ModernTooltip>
            }
            componentClasses={styles.dialog}
            onClose={handleClose}
            content={
                <DialogContent
                    linkText={linkText}
                    linkUrl={linkUrl}
                    content={content}
                    title={title}
                    additionalContent={additionalContent}
                    lottieContent={lottieContent}
                    showMoreLinkHandler={props.showMoreLinkHandler}
                />
            }
            footer={
                <Footer
                    dotsCounter={0}
                    curPageIndex={0}
                    handleConfirmBtn={handleConfirmBtn}
                    handleBackBtn={handleBackBtn}
                    forwardBtnText={forwardBtnText}
                    backwardsBtnText={backwardsBtnText}
                />
            }
        />
    );
};
